module.exports = __webpack_public_path__ + "static/media/Gigalith_gaussian2.81b6292d.png";